export default __webpack_public_path__ + "assets/c7dcbb5235d320da90130af1833bec20.svg";